<template>
  <v-container>
    <br>
    <v-row class="no-padding-row">
      <v-col cols="1" class="force-center no-padding">
        <span>Pin</span>
      </v-col>

      <v-col cols="2" class="align-vertical no-padding">
        <span>Name</span>
      </v-col>

      <v-col cols="2" class="align-vertical no-padding">
        <span>Trigger</span>
      </v-col>

      <v-col cols="1" class="align-vertical no-padding">
        <span>Alert</span>
      </v-col>

      <v-col cols="2" class="align-vertical no-padding">
        <span>Action</span>
      </v-col>
    </v-row>
    
    <IOSetting 
      v-for="(item, index) in pinlist"
      :key="index"
      :pin-list="pinlist"
      :channels="channels"
      :item="item"
      :priority-config="existingLinkToCameraConfigs"
      :disabled-cameras="existingDisabledCameraConfigs"
      :device-model="deviceModel"
      :firmware-version="firmwareVersion"
      @settingsUpdated="settingsRelay"
      @priorityUpdated="handlePriorities"
      @updateConfigPool="handleSelectedPriorities"
      @updatePriority="updatePriority"
      @disableSendSave="disableSendSave"
    />
  </v-container>
</template>

<script>

import IOSetting from '../components/IOSettings.vue';

import { Logger } from "aws-amplify";
const logger = new Logger("IO Main");

export default {
  name: 'IO',
  components: {
    IOSetting
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    deviceModel: {
      type: String,
      required: true
    },
    firmwareVersion: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      priorityConfigs: [],
      existingLinkToCameraConfigs: [],
      existingDisabledCameraConfigs: [],
      actionStateMap: {}
    }
  },
  computed: {
    pinlist() {
      return this.config.device_config.peripheral[0].io[0].pin;
    },
    channels() {
      return this.config.device_config.video[0].camera[0].channel;
    }
  },
  watch: {
    priorityConfigs(val) {
      val.forEach(item => {
        logger.info('priorityConfigs settingsUpdated',item)
        this.$emit('settingsUpdated', item);
      });
    }
  },
  mounted() {
    this.$emit('disableSendSave', false)
    this.compileExistingConfigs();
  },
  methods: {
    disableSendSave(pin, state) {
      // actionStateMap is an object that gets populated when a user selects the disable camera action
      // The given IO pin is the property and the value is a boolean, true if the settings has no cameras selected & false if it has any camera selected
      // If any of the values are true, the send and save buttons on the main config component are to be disabled
      this.actionStateMap[pin] = state

      for(const pin in this.actionStateMap) {
        if (this.actionStateMap[pin]) {
          this.$emit('disableSendSave', true)
          return
        } else {
          this.$emit('disableSendSave', false)
        }
      }
    },
    compileExistingConfigs() {
      let linkToCameraConfigs = this.config.device_config.peripheral[0].io[0].pin.filter(config => {
        return config.action[0].type[0] == 'videoOutFullScreen';
      })
      let disabledCameraConfigs = this.config.device_config.peripheral[0].io[0].pin.filter(config => {
        return config.action[0].type[0] == 'disableCameras';
      })

      this.existingLinkToCameraConfigs = linkToCameraConfigs;
      this.existingDisabledCameraConfigs = disabledCameraConfigs;
    },
    settingsRelay(data, map) {
      logger.info('settingsRelay IO ', data, map)
      this.$emit('settingsUpdated', data, map);
    },
    handlePriorities(data) {
      logger.info('new settings : ', data)
      this.priorityConfigs = data;
    },
    handleSelectedPriorities(data) {
      const index = this.existingLinkToCameraConfigs.indexOf(data.target);

      if(index > -1) {
        this.existingLinkToCameraConfigs.splice(index, 1);
      } else {
        if (data.action == 'Link to Camera') {
          // Append required props
          data.target.action[0].cameraChannel = [];
          data.target.action[0].priority = [];

          data.target.action[0].cameraChannel.push('0');
          data.target.action[0].priority.push('0');

          logger.info('new action : ', data.target)
          this.existingLinkToCameraConfigs.push(data.target);
        }
      }
    },
    updatePriority(data) {
      logger.info('updating priority ', data)
      this.existingLinkToCameraConfigs[data].action[0].priority[0] = '0';

      logger.info('update priority : ', this.existingLinkToCameraConfigs[data]);
    }
  }
}
</script>

<style lang="scss" scoped>
  .no-padding {
    padding: 0 0.25em !important;
    margin: 0 !important;
  }
  .force-center {
    text-align: center;
  }
</style>